
import MaintainerReconciliationDetailView from "../../components/MaintainerReconciliationDetailView";

MaintainerReconciliationDetailScreen.propTypes = {};

function MaintainerReconciliationDetailScreen(props) {

    return (
        <div>
            <MaintainerReconciliationDetailView />
        </div>
    );
}

export default MaintainerReconciliationDetailScreen;
